import { createSlice } from "@reduxjs/toolkit";

const modalErrorSlice = createSlice({
  name: "modalError",
  initialState: {
    open: false,
    content: {},
  },
  reducers: {
    openModalError: (state, action) => {
      state.open = true;
      state.content = action.payload;
    },
    closeModalError: (state) => {
      state.open = false;
      state.content = {};
    },
  },
});

export const selectStateModalError = (state: any) =>
  state.trackingApp.modalError;

export const { openModalError, closeModalError } = modalErrorSlice.actions;

export default modalErrorSlice.reducer;
